import React from 'react';
import PropTypes from 'prop-types';

import PoFormHeader from './PoFormHeader';
import PoFormNavigation from './PoFormNavigation';

const SharedPoForm = ({ StepComponent, ...props }) => {
  return (
    <div className="c-wrapper">
      <PoFormHeader
        disabled={props.busy || props.isOrderGenerated}
        goBack={props.goBack}
        canGoBack={props.canGoBack}
        isLastStep={props.isLastStep}
      />
      <PoFormNavigation activeStep={props.activeStep} goToStep={props.goToStep} />
      <form onSubmit={props.handleSubmit(props.submit)} id="po-form">
        <fieldset disabled={props.busy}>
          <StepComponent
            products={props.products}
            vendors={props.vendors}
            baseUrl={props.baseUrl}
            orderedProducts={props.orderedProducts}
            validateOrder={props.validateOrder}
            validating={props.isValidatingOrder}
            orders={props.orders}
            canDownloadPdf={props.canDownloadPdf}
            downloadPdf={props.downloadPdf}
          />
        </fieldset>
      </form>
    </div>
  );
};

SharedPoForm.propTypes = {
  goToStep: PropTypes.func.isRequired,
  activeStep: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  StepComponent: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  baseUrl: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  vendors: PropTypes.array.isRequired,
  goBack: PropTypes.func.isRequired,
  canGoBack: PropTypes.bool.isRequired,
  orderedProducts: PropTypes.array.isRequired,
  validateOrder: PropTypes.func.isRequired,
  downloadPdf: PropTypes.func.isRequired,
  canDownloadPdf: PropTypes.bool.isRequired,
  orders: PropTypes.array.isRequired,
  isValidatingOrder: PropTypes.bool.isRequired,
  isOrderGenerated: PropTypes.bool.isRequired,
};

export default SharedPoForm;
